import React, { useMemo, useContext, useEffect, useState } from "react";
// @ts-ignore: noImplicitAny
import Board from 'react-trello'
import { SiSpinrilla } from "react-icons/si";
import { collection, query, getDocs, orderBy, where, writeBatch, Timestamp, doc, deleteDoc } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import toast from 'react-hot-toast';
import { throttle, isArray } from 'lodash'

import AddCardLink from '../components/AddCardLink'
import NewLaneSection from '../components/NewLaneSection'
import LaneHeader from '../components/LaneHeader'
import NewLaneForm from '../components/NewLaneForm'
import NewCardForm from '../components/NewCardForm'
import Card from '../components/Card'
import { FirebaseContext } from '../services/Firebase/Context'
import { AuthContext } from "../services/Session/Context";

const TrainingScenarioSection = ({ trainingId, moduleId }: any) => {
  const { db, functions } = useContext(FirebaseContext) || {}
  const { user } = useContext(AuthContext)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<{ lanes: any[]}>({ lanes: [] })

  const deleteOldDoc = (fromLaneId: string, toLaneId: string, cardId: string) => {
    if(!db) {
      return
    }
    deleteDoc(doc(db, "training", trainingId, "modules", moduleId, "sequences", fromLaneId, 'activities', cardId))
    .catch(e => toast.error('Oups, une erreur est survenue...'))
  }

  const onCardDelete = (cardId: string, laneId: string) => {
    if(!db) {
      return
    }
    deleteDoc(doc(db, "training", trainingId, "modules", moduleId, "sequences", laneId, 'activities', cardId))
    .catch(e => toast.error('Oups, une erreur est survenue...'))
  }

  const onLaneDelete = (laneId: string) => {
    if(!functions) return
    const deleteSequences = httpsCallable(functions, 'sequences-call-deleteSequence');
    deleteSequences({ trainId: trainingId, modId: moduleId, seqId:laneId })
    .catch((error) => console.error(error))
  }

  const handleData = (data: any) => {
    if(!user || !db) {
      return
    }
    const batch = writeBatch(db);

    data.lanes.forEach((lane: any, key: number) => {
      let record = {
        ...lane,
        order: key
      }
      if (!lane.userId) {
        record = {
          ...record,
          desc: '',
          organisationId: user.organisationId,
          userId: user.uid,
          createdAt: Timestamp.now(),
        }
      }
      delete record.cards
      delete record.id
      try {
        batch.set(doc(db, "training", trainingId, "modules", moduleId, "sequences", lane.id), record);
        if(isArray(lane.cards)) {
          lane.cards.forEach((card: any, key: number) => {
            let activity = {
              ...card,
              order: key
            }

            if (!card.userId) {
              activity = {
                ...activity,
                organisationId: user.organisationId,
                userId: user.uid,
                createdAt: Timestamp.now(),
              }
            }
            delete activity.id
            delete activity.laneId
            batch.set(doc(db, "training", trainingId, "modules", moduleId, "sequences", lane.id, 'activities', card.id), activity);
          });
        }
      } catch (error) {
        console.log(error)
        toast.error('Oups, une erreur est survenue...')
      }
    });
    toast.promise(batch.commit(),{ 
      loading: 'Enregistrement...',
      success: "Sauvegardé !",
      error: "Une erreur est survenue !"
    })
  }

  const throttledEventHandler = useMemo(
    () => throttle(handleData, 500)
  , [user, db, trainingId, moduleId])

  useEffect(() => {
    let didCancel = false;
    if(!user || !db) return
    setLoading(true)
    const fetchData = async () => {
      try {
        const q = query(collection(db, "training", trainingId, 'modules', moduleId, 'sequences'), where("organisationId", "==", user.organisationId), orderBy('order'));
        const sequencesSnapshot =  await getDocs(q)
        if(didCancel) return
        if(sequencesSnapshot.size === 0) {
          setLoading(false)
          return
        }
        const lanes: any[] = []
        for (const sequence of sequencesSnapshot.docs) {
          const subQuery = query(collection(db, "training", trainingId, 'modules', moduleId, 'sequences', sequence.id, 'activities'), where("organisationId", "==", user.organisationId), orderBy('order'));
          const subQuerySnapshot = await getDocs(subQuery);
          if(didCancel) return
          const activities: any[] = []
          subQuerySnapshot.forEach((act) => {
            activities.push({ id: act.id, ...act.data()})
          })
          lanes.push({
            id: sequence.id,
            cards: activities,
            ...sequence.data(),
          })
        }
        if(didCancel) return
        setData({ lanes })
        setLoading(false)
      } catch (error) {
        toast.error("Oups, une erreur est survenue !")
        setLoading(false)
      }
    }
    fetchData()
    return () => {
      throttledEventHandler.cancel();
      didCancel = true;
    }
  }, [trainingId, moduleId, db, user, throttledEventHandler])

  if(loading) {
    return <div className="justify-center flex flex-col items-center flex-1">
      <SiSpinrilla size={64} className="mr-2 animate-spin text-purple-600 text-center"/>
    </div>
  }

  return (
    <div className="h-full overflow-hidden">
      <Board
        // BUG : This is called at the first render, meaning data is saved at the each render of the component
        onDataChange={throttledEventHandler}
        onCardDelete={onCardDelete}
        onCardMoveAcrossLanes={deleteOldDoc}
        onLaneDelete={onLaneDelete}
        components={{
          AddCardLink: AddCardLink,
          NewLaneSection: NewLaneSection,
          LaneHeader: LaneHeader,
          NewLaneForm: NewLaneForm,
          NewCardForm: NewCardForm,
          Card: Card,
        }}
        data={data}
        //onCardClick={(cardId: string) => { navigate(`/training/${trainingId}/modules/${moduleId}/activities/${cardId}`) }}
        className='!bg-transparent !h-full !overflow-scroll' 
        /* laneDraggable={false}
        cardDraggable={false}
        */
        hideCardDeleteIcon={false}
        canAddLanes
        editLaneTitle
        laneStyle={{
          backgroundColor: 'transparent',
          borderTop: 'solid 3px rgb(147 51 234)',
          boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)'
        }}
        editable
        draggable
        />
    </div>
  );
}

export default TrainingScenarioSection